import { __assign } from "tslib";
import React from "react";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { Platform } from "react-native";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";
import { isIE } from 'react-device-detect';
var useStyles = makeStyles(function (theme) {
  return {
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  };
});
function PnmacAnaModal(props) {
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "modal"
  }, /*#__PURE__*/React.createElement(Modal, {
    style: __assign({
      display: "flex",
      top: isIE ? "15%" : "auto",
      bottom: isIE ? "30%" : 0,
      alignItems: isIE ? "initial" : "center",
      justifyContent: "center",
      height: isIE ? 600 : "100%",
      width: "100%"
    }, props.style),
    className: classes.modal,
    open: props.open,
    onClose: props.handleClose,
    closeAfterTransition: true,
    disableBackdropClick: props.disableClickOut,
    BackdropComponent: Backdrop,
    BackdropProps: {
      timeout: 500
    }
  }, props.children));
}
export default PnmacAnaModal;